<div *ngIf="dataLoaded" class="card card-custom gutter-b">
    <div class="card-header border-0">
        <div class="card-title">
            <h3 class="card-label m-0">View Stage</h3>
        </div>
        <div class="card-toolbar">
            <button type="button" class="btn-back btn-red delete-stage mr-3"
                    (click)="openModal(removeStage)"
                    *ngIf="userRoles | roleChecker : ['ROLE_super_admin', 'ROLE_admin']">
                <span class="fas fa-trash"></span>
            </button>

            <ng-template #removeStage let-c="close">
                <div class="modal-header">
                    <h3 class="modal-title" translate="PROJECTS.REMOVE_STAGE"></h3>
                    <button type="button" class="btn-back" (click)="c()">
                        <span class="fa fa-arrow-left"></span>
                    </button>
                </div>
                <div class="modal-body">
                    <p class="m-0">
                        Are you sure you want to delete this stage?
                    </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn-default btn-main mr-5 border-0 flex-row-reverse"
                            (click)="c()"
                            translate="GENERAL.NO">
                        <span class="fas fa-times mr-3"></span>
                    </button>

                    <button type="button" class="btn-default btn-red border-0 flex-row-reverse"
                            (click)="removeProjectStage(); c()"
                            translate="GENERAL.YES">
                        <span class="fas fa-save mr-3"></span>
                    </button>
                </div>
            </ng-template>

            <button *ngIf="isAllowedToEdit" type="button" class="btn-back mr-3" routerLink="/projects/{{projectId}}/stage/{{stageId}}/edit">
                <span class="fas fa-pen"></span>
            </button>

            <button type="button" class="btn-back" routerLink="/projects/{{projectId}}">
                <span class="fa fa-arrow-left"></span>
            </button>
        </div>
    </div>

    <div class="card-body">
        <div class="row">

            <div class="col-12 col-xl-4 main-column">
                <div class="row h-100">
                    <!--Stage name, color and status-->
                    <div class="col-12 mb-8 top-tile">
                        <div class="mb-8 d-flex justify-content-between align-items-center">
                            <h3 class="form-label section-title m-0">
                                {{ stageData.name | titlecase}}
                            </h3>
                            <span class="stage-label" [ngClass]="stageData.color"></span>
                        </div>

                        <!-- Nu sterge, o sa-l folosim probabil mai tarziu
                        <select class="form-control form-control-lg form-layout custom-select">
                            <option *ngFor="let status of statusList">
                                {{status}}
                            </option>
                        </select>-->
                    </div>

                    <!--Stage description-->
                    <div class="col-12 mb-8">
                        <h3 class="form-label">
                            Description
                        </h3>
                        <textarea readonly class="blue-scroll-bar description-textarea"
                                  [value]="stageData.observation === null ? 'No description' : stageData.observation">
                </textarea>
                    </div>
                </div>
            </div>

            <div class="col-12 col-xl-4 main-column">
                <div class="row">
                    <!--Stage completion-->
                    <div *ngIf="dataLoaded && percentageLoaded" class="col-12 mb-8 top-tile">
                        <h3 class="form-label section-title">
                            Stage Completion
                        </h3>

                        <div class="d-flex flex-column align-items-center justify-content-between project-completion">
                            <apx-chart
                                    [series]="chartOptions.series"
                                    [chart]="chartOptions.chart"
                                    [xaxis]="chartOptions.xaxis"
                                    [yaxis]="chartOptions.yaxis"
                                    [dataLabels]="chartOptions.dataLabels"
                                    [stroke]="chartOptions.stroke"
                                    [legend]="chartOptions.legend"
                                    [fill]="chartOptions.fill"
                                    [states]="chartOptions.states"
                                    [tooltip]="chartOptions.tooltip"
                                    [colors]="chartOptions.colors"
                                    [markers]="chartOptions.markers"
                                    [plotOptions]="chartOptions.plotOptions"
                            ></apx-chart>
                            <p class="mb-8">Tasks completed</p>
                            <div class="progress mb-2">
                                <div class="progress-bar {{barClass}}" role="progressbar" style="width: {{progressBar}}%"></div>
                            </div>
                            <p class="m-0">Due date</p>
                            <span style="color: {{spanColor}}">{{stageData.deadLine | date: 'd MMMM, y' }}</span>
                        </div>
                    </div>

                    <!--Stage members-->
                    <div class="col-12 members-list mb-8">
                        <div class="d-flex justify-content-between align-items-center mb-5">
                            <h3 class="form-label m-0">Assigned Members</h3>
                            <button *ngIf="isAllowedToEdit" type="button" class="btn-square btn-green btn-members"
                                    (click)="openModal(addMember)">
                                <span class="fas fa-user-plus"></span>
                            </button>

                            <ng-template #addMember let-c="close">
                                <div class="modal-header">
                                    <h3 class="modal-title" translate="PROJECTS.ADD_NEW_MEMBER"></h3>
                                    <button type="button" class="btn-back" (click)="c()">
                                        <span class="fa fa-arrow-left"></span>
                                    </button>
                                </div>
                                <div class="modal-body modal-members">
                                    <app-form-message *ngIf="formSent" [success]="formResponse" [customErrorMessage]="errorMsg"
                                                      [customSuccessMessage]="successMsg"></app-form-message>

                                    <div *ngIf="allUsersInfo.length === 0">
                                        <p>No members assigned to this project</p>
                                    </div>

                                    <div *ngFor="let user of allUsersInfo" class="row align-items-center mb-4">
                                        <div class="col-5 col-sm-4 d-flex align-items-center pr-0">
                                            <img src="{{user.profileImagePath}}">
                                            <p class="bold-text ml-3">{{user.firstName + ' ' + user.lastName}}</p>
                                        </div>

                                        <div class="col-5 col-sm-4 d-flex justify-content-center">
                                            <p>{{ (user.department === '' || user.department === null) ? 'No Department' : user.department }}</p>
                                        </div>

                                        <div class="col-2 col-sm-4 d-flex justify-content-end">
                                            <button type="button" class="btn-default btn-green add-member" (click)="addNewMember(user)">
                                                <span class="fas fa-plus"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>

                        <div *ngIf="responsibleStaff && responsibleStaff.length === 0" class="col-12 d-flex justify-content-center align-items-center">
                            <p>No Members assigned</p>
                        </div>

                        <div *ngFor="let member of responsibleStaff | slice:0:3; let i = index" class="row align-items-center mb-4">
                            <div class="col-10 col-sm-8 d-flex align-items-center pr-0">
                                <!--<img src="{{member.image}}">-->
                                <p class="bold-text">{{member.responsibleName | titlecase}}</p>
                            </div>

                            <!--                    <div class="col-5 col-sm-4 d-flex justify-content-center">
                                                    <p>{{ member.dep === '' ? 'No Department' : member.dep }}</p>
                                                </div>-->

                            <div *ngIf="isAllowedToEdit" class="col-2 col-sm-4 d-flex justify-content-end">
                                <div ngbDropdown class="card-label">
                                    <button type="button" class="btn btn-clean btn-hover-light-primary btn-lg btn-icon"
                                            id="membersDropdown" ngbDropdownToggle>
                                        <span class="fas fa-ellipsis-h"></span>
                                    </button>
                                    <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="membersDropdown">
                                        <button class="dropdown-item" (click)="removeMember(member.responsibleId, i)">
                                            Remove Member
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button class="btn-all-members" *ngIf="responsibleStaff.length > 3" (click)="openModal(allMembers)">
                            View All Members
                        </button>

                        <ng-template #allMembers let-c="close">
                            <div class="modal-header">
                                <h3 class="modal-title" translate="PROJECTS.ALL_MEMBERS"></h3>
                                <button type="button" class="btn-back" (click)="c()">
                                    <span class="fa fa-arrow-left"></span>
                                </button>
                            </div>
                            <div class="modal-body modal-members">
                                <div *ngFor="let member of responsibleStaff; let i = index" class="row align-items-center mb-4">
                                    <div class="col-5 col-sm-4 d-flex align-items-center pr-0">
                                        <img src="{{member.image}}">
                                        <p class="bold-text ml-3">{{member.responsibleName | titlecase}}</p>
                                    </div>

                                    <div class="col-5 col-sm-4 d-flex justify-content-center">
                                        <p>{{ member.dep === '' ? 'No Department' : member.dep }}</p>
                                    </div>

                                    <div *ngIf="isAllowedToEdit" class="col-2 col-sm-4 d-flex justify-content-end">
                                        <div ngbDropdown class="card-label">
                                            <button type="button" class="btn btn-clean btn-hover-light-primary btn-lg btn-icon"
                                                    id="allMembersDropdown" ngbDropdownToggle>
                                                <span class="fas fa-ellipsis-h"></span>
                                            </button>
                                            <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="allMembersDropdown">
                                                <button class="dropdown-item" (click)="removeMember(member.responsibleId, i)">
                                                    Remove Member
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>

                    </div>
                </div>
            </div>

            <!--Stage tasks-->
            <div class="col-12 col-xl-4 main-column tasks-column top-tile">
                <div class="d-flex justify-content-between align-items-center mb-5">
                    <h3 class="form-label m-0">Tasks</h3>
                    <button *ngIf="isAllowedToEdit" type="button" class="btn-square btn-green"
                            (click)="openModal(addTask)">
                        <span class="fas fa-plus"></span>
                    </button>

                    <ng-template #addTask let-c="close">
                        <div class="modal-header">
                            <h3 class="modal-title" translate="PROJECTS.NEW_TASK"></h3>
                            <button type="button" class="btn-back" (click)="c()">
                                <span class="fa fa-arrow-left"></span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <app-form-message *ngIf="formSent" [success]="formResponse" [customErrorMessage]="errorMsg"
                                              [customSuccessMessage]="successMsg"></app-form-message>

                            <form [formGroup]="newTaskForm" (ngSubmit)="submitTaskForm()">
                                <div class="row">
                                    <div class="col-12 form-group">
                                        <p class="form-label">Task Name</p>
                                        <input class="form-control form-control-lg form-layout"
                                               type="text"
                                               formControlName="name"
                                               [class.is-invalid]="isControlInvalid('name')">
                                        <div class="invalid-feedback" *ngIf="controlHasError('required', 'name')">
                                            This field is required!
                                        </div>
                                    </div>

                                    <div class="col-12 form-group">
                                        <p class="form-label">Description</p>
                                        <textarea class="form-control form-control-lg form-layout"
                                                  formControlName="description"
                                        ></textarea>
                                    </div>

                                    <div class="col-12 form-group">
                                        <p class="form-label">Due Date</p>
                                        <input class="form-control form-control-lg form-layout"
                                               type="date"
                                               formControlName="dueDate"
                                               [class.is-invalid]="isControlInvalid('dueDate')">
                                        <div class="invalid-feedback" *ngIf="controlHasError('required', 'dueDate')">
                                            This field is required!
                                        </div>
                                    </div>

                                    <div class="col-12 form-group">
                                        <p class="form-label">Responsible Member</p>
                                        <select class="form-control form-control-lg form-layout custom-select"
                                                formControlName="responsible">
                                            <option *ngIf="responsibleStaff.length === 0"
                                                    [ngValue]="''">
                                                None
                                            </option>
                                            <option *ngFor="let user of responsibleStaff"
                                                    [ngValue]="user.responsibleId">
                                                {{user.responsibleName}}
                                            </option>
                                        </select>

                                    </div>

                                    <div class="col-12 form-group">
                                        <p class="form-label">New checklist item</p>
                                        <div class="d-flex justify-content-between align-items-center mb-5">
                                            <input class="form-control form-control-lg form-layout"
                                                   type="text" #subTaskInput>
                                            <button type="button" class="btn-default btn-green ml-4"
                                                    (click)="pushSubTask(subTaskInput.value)">
                                                <span class="fas fa-plus"></span>
                                            </button>
                                        </div>

                                        <p *ngIf="subTasks.length > 0" class="form-label">Task Checklist:</p>
                                        <div *ngFor="let subTask of subTasks; let i = index"
                                             class="d-flex justify-content-between align-items-center mb-3">
                                            <p>{{ subTask.description }}</p>
                                            <button type="button" class="btn-list btn-red"
                                                    (click)="removeSubTask(i)">
                                                <span class="fas fa-trash-alt"></span>
                                            </button>
                                        </div>

                                    </div>

                                    <div class="col-12 d-flex justify-content-end">
                                        <button type="submit" class="btn-default btn-green">
                                            Create
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </ng-template>
                </div>

                <div *ngIf="tasks.length === 0" class="col-12 d-flex justify-content-center align-items-center">
                    <p>No tasks assigned</p>
                </div>

                <div class="tasks-container blue-scroll-bar">
                    <div *ngFor="let task of tasks; let i = index" class="row align-items-center task-row">
                        <div class="col-10 d-flex justify-content-start align-items-center task-label"
                             (click)="onClickTask(task)"
                             routerLink="/projects/{{projectId}}/stage/{{stageId}}/view/{{task.id}}/view">
                            <p class="bold-text m-0">{{task.messageTitle}}</p>
                        </div>

                        <div *ngIf="allowedToRemoveTasks" class="col-2 d-flex justify-content-end">
                            <div ngbDropdown class="card-label">
                                <button type="button" class="btn btn-clean btn-hover-light-primary btn-lg btn-icon"
                                        id="tasksDropdown" ngbDropdownToggle>
                                    <span class="fas fa-ellipsis-h"></span>
                                </button>
                                <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="tasksDropdown">
                                    <button class="dropdown-item" (click)="removeTask(task.id, i)">
                                        Remove Task
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
